const IMAGE_EXTENSIONS = /\.(jpe?g|png|gif|webp|bmp|svg|avif|tiff?)$/i;

export const isImageUrl = (url: string): boolean => {
  if (url.startsWith('data:image/')) return true;
  try {
    const pathname = new URL(url).pathname;
    return IMAGE_EXTENSIONS.test(pathname);
  } catch {
    return IMAGE_EXTENSIONS.test(url);
  }
};

export const capturePhotoDataUrl = (videoElementId: string): string => {
  const canvas = document.createElement('canvas');
  canvas.width = 640;
  canvas.height = 480;
  const ctx = canvas.getContext('2d');
  const video = document.getElementById(videoElementId) as HTMLVideoElement | null;
  if (ctx && video) {
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
  }
  return canvas.toDataURL('image/jpeg');
};
